// import React, { Fragment, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import styles from "./Signin.module.scss";
// import logo from "../assets/images/logo/image.png";

// // ── Hardcoded users ───────────────────────────────────────────
// const USERS = [
//   {
//     username: "company",
//     password: "Company@123",
//     redirect: "/company/dashboard",
//   },
//   {
//     username: "platform",
//     password: "Platform@123",
//     redirect: "/platform/dashboard",
//   },
// ];

// // ── Eye icons ─────────────────────────────────────────────────
// const EyeOpen = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
//     <circle cx="12" cy="12" r="3" />
//   </svg>
// );

// const EyeClosed = () => (
//   <svg
//     width="18"
//     height="18"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
//     <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
//     <line x1="1" y1="1" x2="23" y2="23" />
//   </svg>
// );

// // ─────────────────────────────────────────────────────────────
// const Signin = () => {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});

//   const navigate = useNavigate();

//   // ── Validation ──────────────────────────────────────────────
//   const validate = () => {
//     const e = {};
//     if (!username.trim()) e.username = "Username is required";
//     if (!password) e.password = "Password is required";
//     return e;
//   };

//   // ── Submit ──────────────────────────────────────────────────
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const validationErrors = validate();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }

//     setErrors({});
//     setLoading(true);

//     // Simulate a brief loading delay for UX
//     setTimeout(() => {
//       const matched = USERS.find(
//         (u) =>
//           u.username.toLowerCase() === username.trim().toLowerCase() &&
//           u.password === password,
//       );

//       if (matched) {
//         localStorage.setItem("login", JSON.stringify(true));
//         localStorage.setItem("username", matched.username);
//         toast.success(`Welcome back, ${matched.username}!`);
//         navigate(matched.redirect);
//       } else {
//         toast.error("Invalid username or password.");
//         setLoading(false);
//       }
//     }, 600);
//   };

//   return (
//     <Fragment>
//       {/* DM Sans font */}
//       <link rel="preconnect" href="https://fonts.googleapis.com" />
//       <link
//         href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap"
//         rel="stylesheet"
//       />

//       <div className={styles.page}>
//         {/* Background decorative circles */}
//         <div className={styles.bgCircle1} />
//         <div className={styles.bgCircle2} />

//         <div className={styles.card}>
//           {/* Logo */}
//           <div className={styles.logoWrap}>
//             <img src={logo} alt="MeetingHub AI" className={styles.logoImg} />
//           </div>

//           {/* Gradient divider */}
//           <div className={styles.divider} />

//           <h2 className={styles.heading}>Welcome Back</h2>
//           <p className={styles.subheading}>Sign in to the Admin Portal</p>

//           <form onSubmit={handleSubmit} noValidate>
//             {/* Username */}
//             <div className={styles.fieldWrap}>
//               <label className={styles.label} htmlFor="username">
//                 Username
//               </label>
//               <div className={styles.inputInner}>
//                 <input
//                   id="username"
//                   type="text"
//                   autoComplete="username"
//                   placeholder="Enter your username"
//                   value={username}
//                   onChange={(e) => {
//                     setUsername(e.target.value);
//                     setErrors((p) => ({ ...p, username: "" }));
//                   }}
//                   className={styles.input}
//                 />
//               </div>
//               {errors.username && (
//                 <div className={styles.errorText}>{errors.username}</div>
//               )}
//             </div>

//             {/* Password */}
//             <div className={styles.fieldWrap}>
//               <label className={styles.label} htmlFor="password">
//                 Password
//               </label>
//               <div className={styles.inputInner}>
//                 <input
//                   id="password"
//                   type={showPassword ? "text" : "password"}
//                   autoComplete="current-password"
//                   placeholder="Enter your password"
//                   value={password}
//                   onChange={(e) => {
//                     setPassword(e.target.value);
//                     setErrors((p) => ({ ...p, password: "" }));
//                   }}
//                   className={`${styles.input} ${styles.hasEye}`}
//                 />
//                 <button
//                   type="button"
//                   className={styles.eyeBtn}
//                   tabIndex={-1}
//                   aria-label={showPassword ? "Hide password" : "Show password"}
//                   onClick={() => setShowPassword((v) => !v)}
//                 >
//                   {showPassword ? <EyeOpen /> : <EyeClosed />}
//                 </button>
//               </div>
//               {errors.password && (
//                 <div className={styles.errorText}>{errors.password}</div>
//               )}
//             </div>

//             {/* Remember me + Forgot password */}
//             <div className={styles.row}>
//               <label className={styles.checkLabel}>
//                 <input
//                   type="checkbox"
//                   checked={rememberMe}
//                   onChange={(e) => setRememberMe(e.target.checked)}
//                 />
//                 Remember me
//               </label>
//               <a href="#forgot" className={styles.forgotLink}>
//                 Forgot password?
//               </a>
//             </div>

//             {/* Submit */}
//             <button type="submit" className={styles.btn} disabled={loading}>
//               {loading ? "Signing in…" : "Sign In"}
//             </button>
//           </form>
//         </div>
//       </div>
//     </Fragment>
//   );
// };

// export default Signin;
import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styles from "./Signin.module.scss";
import logo from "../assets/images/logo/image.png";
import { loginAPI } from "../api/api";

// ── Eye icons ─────────────────────────────────────────────────
const EyeOpen = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeClosed = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

// ── Role helpers (case-insensitive) ───────────────────────────
// Normalise roles array to lowercase once
const normaliseRoles = (roles = []) => roles.map((r) => r.toLowerCase());

const isPlatform = (roles = []) =>
  normaliseRoles(roles).includes("platform_owner");

const getRedirect = (roles = []) =>
  isPlatform(roles) ? "/platform/dashboard" : "/company/dashboard";

const getScope = (roles = []) => (isPlatform(roles) ? "platform" : "company");

// ── Read scope from localStorage (case-insensitive) ──────────
// Use this helper anywhere instead of reading "scope" directly.
export const getScopeFromStorage = () => {
  try {
    const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    return getScope(roles);
  } catch {
    return "company";
  }
};

// ─────────────────────────────────────────────────────────────
const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const validate = () => {
    const e = {};
    if (!email.trim()) e.email = "Email is required";
    if (!password) e.password = "Password is required";
    return e;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      const { data } = await loginAPI({ email: email.trim(), password });
      const { token, user } = data;

      // Normalise roles to lowercase before storing
      const roles = normaliseRoles(user.roles);

      localStorage.setItem("token", token);
      localStorage.setItem("userId", user.userId);
      localStorage.setItem("tenantId", user.tenantId);
      localStorage.setItem("email", user.email);
      localStorage.setItem("name", user.name);
      localStorage.setItem("roles", JSON.stringify(roles)); // stored lowercase
      localStorage.setItem("scope", getScope(roles)); // "platform" | "company"

      if (rememberMe) {
        localStorage.setItem("rememberedEmail", email.trim());
      } else {
        localStorage.removeItem("rememberedEmail");
      }

      toast.success(`Welcome back, ${user.name}!`);
      navigate(getRedirect(roles));
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Invalid email or password.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />

      <div className={styles.page}>
        <div className={styles.bgCircle1} />
        <div className={styles.bgCircle2} />

        <div className={styles.card}>
          <div className={styles.logoWrap}>
            <img src={logo} alt="MeetingHub AI" className={styles.logoImg} />
          </div>

          <div className={styles.divider} />

          <h2 className={styles.heading}>Welcome Back</h2>
          <p className={styles.subheading}>Sign in to the Admin Portal</p>

          <form onSubmit={handleSubmit} noValidate>
            {/* Email */}
            <div className={styles.fieldWrap}>
              <label className={styles.label} htmlFor="email">
                Email
              </label>
              <div className={styles.inputInner}>
                <input
                  id="email"
                  type="email"
                  autoComplete="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setErrors((p) => ({ ...p, email: "" }));
                  }}
                  className={styles.input}
                />
              </div>
              {errors.email && (
                <div className={styles.errorText}>{errors.email}</div>
              )}
            </div>

            {/* Password */}
            <div className={styles.fieldWrap}>
              <label className={styles.label} htmlFor="password">
                Password
              </label>
              <div className={styles.inputInner}>
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrors((p) => ({ ...p, password: "" }));
                  }}
                  className={`${styles.input} ${styles.hasEye}`}
                />
                <button
                  type="button"
                  className={styles.eyeBtn}
                  tabIndex={-1}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  onClick={() => setShowPassword((v) => !v)}
                >
                  {showPassword ? <EyeOpen /> : <EyeClosed />}
                </button>
              </div>
              {errors.password && (
                <div className={styles.errorText}>{errors.password}</div>
              )}
            </div>

            {/* Remember me + Forgot password */}
            <div className={styles.row}>
              <label className={styles.checkLabel}>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                Remember me
              </label>
              <a href="#forgot" className={styles.forgotLink}>
                Forgot password?
              </a>
            </div>

            <button type="submit" className={styles.btn} disabled={loading}>
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default Signin;
